export const TRANSLATION = 'builder.dashboard.job_search_help.auto_apply.widget'
